import React, { useContext } from 'react';

import { Menu as MenuConstants } from 'src/modules/designStudio/constants';

import { historyContext } from '../../../providers';

import { RoofMenu } from './RoofMenu';
import { TrimMenu } from './TrimMenu';
import { WallMenu } from './WallMenu';
import { WindowMenu } from './WindowMenu';

const MenuComponentMap = {
  [MenuConstants.TRIM]: TrimMenu,
  [MenuConstants.WALL]: WallMenu,
  [MenuConstants.ROOF]: RoofMenu,
  [MenuConstants.WINDOW]: WindowMenu,
  [MenuConstants.ACCENT]: null,
  [MenuConstants.DOOR]: null,
  [MenuConstants.INACTIVE_WINDOW]: null,
  [MenuConstants.ACCENT]: null,
  [MenuConstants.VERSION]: null,
  [MenuConstants.RESET]: null,
  [MenuConstants.SHARE]: null,
};

export const Menu = ({ menu }: { menu: MenuConstants | null }) => {
  const {
    historyState: { designConfig },
    updateDesign,
  } = useContext(historyContext);

  const MenuComponent = menu && MenuComponentMap[menu];

  if (!MenuComponent) return null;

  return (
    <MenuComponent designConfig={designConfig} updateDesign={updateDesign} />
  );
};
